<template>
    <div>
        <v-list-item :value="item" style="min-height: 60px;">
            <template>
                <v-list-item-content>
                    <div v-if="layer === 1" style="position:relative;display:grid;grid-template-columns: 14% 4% 14% 14% 38% 4% 12%;grid-template-rows: 60px;">
                            <!-- <span style="margin-left: 15px">
                                <p style="margin:0;">
                                    {{ item.leg.filter(child => child.type !== 'missingFlight').length }}
                                </p>
                            </span> -->
                            <span style="display: flex;align-items: center;">
                                <p style="margin:0;" :class="get_ClassForEditedRow(item)">
                                    <span>{{ $dayjsLocalToUTC(item.date, 'DD.MM.YYYY') }}</span>
                                    <span v-if="item.lastDate"> -{{ $dayjsLocalToUTC(item.lastDate, 'DD.MM.YYYY') }}</span>
                                </p>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <p style="margin:0;">{{ $dayjsLocalToUTC(item.date, 'vt') }}</p>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <p style="margin:0">{{ item.children[0].children[0].leg.aircraft.code }}</p>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                {{ item.rotationObject.flightNo }}
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
								<div style="display:grid;grid-template-rows: 30px 30px;" :style="{gridTemplateColumns: item.rotationObject.gridTemplateColumns}">
									<div v-for="(route, i) in item.rotationObject.route" :key="i" style="margin-right:21px;display:flex;" :style="{justifyContent: route.justifyContent}" v-html="route.route" />
								</div>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                {{ item.rotationObject.flightModus }}
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <v-tooltip
                                    v-for="(warning, index) in item.warnings"
                                    :key="index"
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            color="red"
                                            :style="{marginLeft: index !== 0 ? '14px' : ''}"
                                            v-bind="attrs"
                                            v-on="on">
                                            {{ warning.icon }}
                                        </v-icon>
                                    </template>
                                    <span>{{ warning.text }}</span>
                                </v-tooltip>
                            </span>
                            <div style="position:absolute;left:-40px;bottom:-12px;border-bottom:1px solid #dbdbdb;width:100%;" />
                    </div>
                    <div v-if="layer === 2" style="position:relative;display:grid;grid-template-columns: 14% 4% 14% 14% 38% 4% 12%;grid-template-rows: 60px;">
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <p
                                    style="margin:0;" :class="get_ClassForEditedRow(item)">
                                    {{ $dayjsLocalToUTC(item.children[0].leg.dep_sch_time, 'DD.MM.YYYY') }}
                                </p>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <p style="margin:0;">{{ $dayjsLocalToUTC(item.children[0].leg.dep_sch_time, 'vt') }}</p>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <p
                                    style="margin:0">
                                    {{ item.children[0].leg.aircraft.code }}
                                </p>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                {{ item.rotationObject.flightNo }}
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <div style="display:grid;grid-template-rows: 30px 30px;" :style="{gridTemplateColumns: item.rotationObject.gridTemplateColumns}">
									<div v-for="(route, i) in item.rotationObject.route" :key="i" style="margin-right:21px;display:flex;" :style="{justifyContent: route.justifyContent}" v-html="route.route" />
								</div>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                {{ item.rotationObject.flightModus }}
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <v-tooltip
                                    v-for="(warning, index) in item.warnings"
                                    :key="index"
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            color="red"
                                            :style="{marginLeft: index !== 0 ? '14px' : ''}"
                                            v-bind="attrs"
                                            v-on="on">
                                            {{ warning.icon }}
                                        </v-icon>
                                    </template>
                                    <span>{{ warning.text }}</span>
                                </v-tooltip>
                            </span>
                            <div style="position:absolute;left:-40px;bottom:-12px;border-bottom:1px solid #dbdbdb;width:100%;" />
                    </div>
                    <div v-if="layer === 3" style="position:relative;display:grid;grid-template-columns: 14% 4% 14% 14% 38% 4% 12%;grid-template-rows: 60px;">
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <p
                                    style="margin:0;">
                                    {{ $dayjsLocalToUTC(item.leg.dep_sch_time, 'DD.MM.YYYY') }}
                                </p>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <p style="margin:0;">{{ $dayjsLocalToUTC(item.leg.dep_sch_time, 'vt') }}</p>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <p
                                    style="margin:0">
                                    {{ item.leg.aircraft.code }}
                                </p>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <p style="margin:0">
                                    {{ item.leg.flightNo }}
                                </p>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <div style="margin:0;">
                                    <div style="display:grid;grid-template-columns: 80px 80px;grid-template-rows: 30px 30px;">
                                        <div style="margin-right:21px;">{{ item.leg.aptFrom.aptCode }}{{ $dayjsLocalToUTC(item.leg.dep_sch_time, 'HHmm') }}</div>
                                        <div style="margin-right:21px;text-align:end;">{{ $dayjsLocalToUTC(item.leg.arr_sch_time, 'HHmm') }}{{ item.leg.aptTo.aptCode }}</div>

                                        <div style="margin-right:21px;">{{ item.leg.aptFrom.aptCode }}<span v-html="helper_getSlotInfo(item.leg.aptFrom, item.leg.dep_sch_time, item.leg.dep_slt_time)" /></div>
                                        <div style="margin-right:21px;text-align:end;"><span v-html="helper_getSlotInfo(item.leg.aptTo, item.leg.arr_sch_time, item.leg.arr_slt_time)" />{{ item.leg.aptTo.aptCode }}</div>
                                    </div>
                                </div>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <p style="margin:0">
                                    {{ item.leg.mainServiceType }}
                                </p>
                            </span>
                            <span style="margin-left: 15px;display: flex;align-items: center;">
                                <v-tooltip
                                    v-for="(warning, index) in item.warnings"
                                    :key="index"
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            color="red"
                                            :style="{marginLeft: index !== 0 ? '14px' : ''}"
                                            v-bind="attrs"
                                            v-on="on">
                                            {{ warning.icon }}
                                        </v-icon>
                                    </template>
                                    <span>{{ warning.text }}</span>
                                </v-tooltip>
                            </span>
                            <div style="position:absolute;left:-40px;bottom:-12px;border-bottom:1px solid #dbdbdb;width:100%;" />
                    </div>
                </v-list-item-content>
            </template>
        </v-list-item>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';


    export default {
        name: 'Selectedflightslistitem', // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {},

        /* >>> *************************************************************** / /* Props */
        props: {

            item: Object,
            layer: Number

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {};

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([])

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function () {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/SelectedFlightListItem.vue >>> created');

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function () {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/SelectedFlightListItem.vue >>> destroyed');

        }, // eo function destroyed()



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /******************************************************************* ''
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_ClassForEditedRow()
            *
            * Desc: Returns selected Class if Row was edited (prop: 'wasEdited')
            * Note:
            *
            */
			get_ClassForEditedRow: function(item) {

                const me = this;


                me.$toc('>>> views/flights/flights/components/crud/SelectedFlightListItem.vue >>> get_ClassForEditedRow');
				return item.wasEdited === true ? 'rowWasEdited' : '';

            }, // eo function get_ClassForEditedRow()

            /*******************************************************************
			* helper_getSlotInfo()
			*
			* Desc: Checks if Slot is needed and mismatching slot
            * Note:
            *
			*/
			helper_getSlotInfo: function (apt, scheduled, slot) {

				let color = 'black',
					time = '';

				if (apt.coordinated) {
					if (Vue.prototype.$isMismatchingSlot(scheduled, slot)) {
						color = 'red';
					}
					if (!slot) {
						time = 'XXXX';
					} else {
						time = Vue.prototype.$dayjsLocalToUTC(slot, 'HHmm');
					}

					return `<span style="color:${color}">${time}</span>`;
				} else {

					return '';
				}
			} // eo function helper_getSlotInfo()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style scoped>
    .v-card .v-divider {
        border-color: #d2d2d2;
    }

    .v-list-item {
        padding: 0 26px;
    }
    .rowWasEdited {
        /* border-left: 4px solid #AB3B7C;
        padding-left: 4px; */
        /* background-color: #AB3B7C; */
        border: 2px solid #AB3B7C;
        padding: 2px;
	}
</style>
